module.exports = __webpack_public_path__ + "img/金华市.980f5207.png";